import { render, staticRenderFns } from "./FinalVideo.vue?vue&type=template&id=f2066c30&scoped=true&lang=pug&"
import script from "./FinalVideo.vue?vue&type=script&lang=js&"
export * from "./FinalVideo.vue?vue&type=script&lang=js&"
import style0 from "./FinalVideo.vue?vue&type=style&index=0&id=f2066c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2066c30",
  null
  
)

export default component.exports